// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1-EYj","info":"PatientInfo_info__XR1VJ"};